import React, { useState } from 'react';
import api from '../api';
import { Key, CheckCircle } from 'lucide-react';

const ChangePassword = () => {
  const [form, setForm] = useState({ current_password: '', new_password: '', confirm_password: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);

    if (form.new_password !== form.confirm_password) {
      setError('Neue Passwörter stimmen nicht überein.');
      return;
    }

    if (form.new_password.length < 10) {
      setError('Passwort muss mindestens 10 Zeichen lang sein.');
      return;
    }

    setLoading(true);
    try {
      await api.put('/auth/password', {
        current_password: form.current_password,
        new_password: form.new_password,
      });
      setSuccess(true);
      setForm({ current_password: '', new_password: '', confirm_password: '' });
    } catch (err) {
      setError(err.response?.data?.details?.join('\n') || err.response?.data?.error || 'Fehler beim Ändern des Passworts.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="page-header">
        <h2>Passwort ändern</h2>
        <p>Ändern Sie Ihr persönliches Passwort</p>
      </div>

      <div className="card" style={{ maxWidth: 480 }}>
        <div className="card-body">
          {success && (
            <div style={{ background: '#dcfce7', border: '1px solid #86efac', borderRadius: 6, padding: '12px 16px', marginBottom: 16, fontSize: '0.85rem', color: '#166534', display: 'flex', alignItems: 'center', gap: 8 }}>
              <CheckCircle size={16} /> Passwort erfolgreich geändert.
            </div>
          )}

          {error && (
            <div className="login-error" style={{ marginBottom: 16 }}>{error}</div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Aktuelles Passwort</label>
              <input type="password" className="form-control" value={form.current_password}
                onChange={(e) => setForm({ ...form, current_password: e.target.value })} required />
            </div>
            <div className="form-group">
              <label>Neues Passwort</label>
              <input type="password" className="form-control" value={form.new_password}
                onChange={(e) => setForm({ ...form, new_password: e.target.value })} required minLength={10} />
              <span className="form-hint">Min. 10 Zeichen, Groß-/Kleinbuchstaben und Zahl</span>
            </div>
            <div className="form-group">
              <label>Neues Passwort bestätigen</label>
              <input type="password" className="form-control" value={form.confirm_password}
                onChange={(e) => setForm({ ...form, confirm_password: e.target.value })} required minLength={10} />
            </div>
            <button type="submit" className="btn btn-primary" disabled={loading} style={{ marginTop: 8 }}>
              <Key size={16} />
              {loading ? 'Wird geändert...' : 'Passwort ändern'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
